export function isEmptyText(content?: string): boolean {
  return content === undefined || content === '';
}
